import React, { useEffect, useState } from 'react';
import {
  ProductsPage,
  PageHeader,
  PageTitle,
  AddProductButton,
  ProductsStats,
  StatItem,
  StatNumber,
  StatLabel
} from '../../styles/ProductsStyles';
import { AddButton, Dropdown, Field, HeadersModal, Input, Item, Label, ListActionButton, ListActions, ListCategory, ListInfo, ListItem, ListName, ModalContent, ModalOverlay, ProductsList, TabButton, TabHeader, TabsWrapper } from '../../styles/common';
import { useNavigate, useSearchParams, } from "react-router-dom";
import Swal from 'sweetalert2';
import { GetSubSubCategories, UpdateSubSubCategoryStatus } from '../../common/CommonApi';
import styled from 'styled-components';
import { ActionButton, UserActions } from '../../styles/UsersStyles';

const ATTRIBUTE_KEYS = [
  'Fabric', 'Material', 'Fit', 'Pattern', 'Sleeve Type', 'Neck Type', 'Neckline',
  'Collar Type', 'Length', 'Waist Rise', 'Waist Type', 'Closure Type', 'Occasion',
  'Season', 'Work / Embellishment', 'Set Components', 'Skin Type', 'Hair Type',
  'Skin Concern', 'Hair Concern', 'Product Type', 'Formulation', 'Texture', 'Finish',
  'Shade', 'Key Ingredients', 'SPF', 'Fragrance Type', 'Volume', 'Net Quantity',
  'Bag Type', 'Capacity', 'Compartments', 'Dimensions', 'Frame Shape', 'Frame Material',
  'Lens Material', 'UV Protection', 'Movement', 'Display Type', 'Bed Size',
  'Thread Count', 'GSM', 'Opacity', 'Shape', 'Filling Material', 'Mount Type',
  'Light Type', 'Upper Material', 'Sole Material', 'Toe Shape', 'Heel Type',
  'Heel Height', 'Size Standard', 'Jewellery Type', 'Base Metal', 'Metal Purity',
  'Plating', 'Stone Type', 'Gemstone', 'Chain Length', 'Bracelet Length',
  'Pendant Type', 'Adjustable'
];

const EMPTY_FORM = {
  subcategoryName: '',
  description: '',
  status: true,
  sortOrder: 0,
  showInMenu: true,
  subcategoryImage: null,
  attributeKeys: [],
};

const SubSubCategory = () => {
  const [searchParams] = useSearchParams();
  const catid = searchParams.get("catid");
  const subCatid = searchParams.get("subCatid");
  const [editCat, setEditCat] = useState(false);
  const [activeTab, setActiveTab] = useState("tab1");
  const [editId, setEditId] = useState('');
  const [products] = useState([
    { id: 1, name: "Men's Jeans", status: 'Active', order: 1, category: 'Mens', status: 'Active', image: '../assets/mens.png' },
    { id: 2, name: "Men`s Shirts", status: 'Active', order: 2, category: 'Womens', status: 'Active', image: '../assets/womens.png' },
    { id: 3, name: "Men`s Kurtas", status: 'Active', order: 3, category: 'footwear', status: 'Active', image: '../assets/footwear.png' },
    { id: 4, name: "Men`s Blazers", status: 'Active', order: 4, category: 'beauty', image: '../assets/beauty.png' },
    { id: 5, name: "Men`s Raincot", status: 'Active', order: 5, category: 'Accessories', image: '../assets/Accessories.png' },
    { id: 6, name: "Men`s Suits", status: 'Active', order: 5, category: 'Accessories', image: '../assets/Accessories.png' }
  ]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCategory, setFilterCategory] = useState('All');
  const [addCategory, setAddCategory] = useState(false);
  
  const [form, setForm] = useState(EMPTY_FORM);
  const [attributeSearch, setAttributeSearch] = useState('');
  const [showAttributeOptions, setShowAttributeOptions] = useState(false);
  const [categories, setCategories] = useState([]);
  useEffect(() => {
    getCategory()
  }, [])

  const filteredProducts = products.filter(product => {
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = filterCategory === 'All' || product.category === filterCategory;
    return matchesSearch && matchesCategory;
  });

  // function SubCategory(){    
  //   navigate('/sub-category');
  // }


  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    const isBooleanField = name === "status" || name === "showInMenu";

    setForm((prevForm) => ({
      ...prevForm,
      [name]:
        type === "checkbox"
          ? checked
          : type === "file"
            ? files[0]   // 👈 will store in form.categoryImage
            : name === "sortOrder"
              ? Number(value)
              : isBooleanField
                ? value === "true"
              : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("subcategoryName", form.subcategoryName);
    formData.append("description", form.description);
    formData.append("status", form.status);
    formData.append("sortOrder", form.sortOrder);
    formData.append("showInMenu", form.showInMenu);
    formData.append("categoryId", catid);
    formData.append("subCatId", subCatid);
    formData.append("attributeKeys", JSON.stringify(form.attributeKeys));

    if (form.subcategoryImage) {
      formData.append("subsubcategoryImage", form.subcategoryImage);
    }
    if (editCat) {
      const response = await fetch(`${process.env.REACT_APP_API_URL}subsubcategories/${editId}`, {
        method: "PUT",
        body: formData,
      });
      const data = await response.json();
      if (data.message == "SUCCESSFULLY_UPDATED") {
        Swal.fire('Sub Categories Updated.')
        setAddCategory(false)
        setForm(EMPTY_FORM)
        getCategory()
      }
      console.log("Success:", data);

    } else {
      const response = await fetch(process.env.REACT_APP_API_URL + "subsubcategories", {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data.message == "SUCCESS_FULLY_CREATED") {
        Swal.fire('Sub Sub Categories Added.')
        setAddCategory(false)
        setForm(EMPTY_FORM)
        getCategory()
      }

      console.log("Success:", data);
    }
  };

  const getCategory = async () => {
    let data = await GetSubSubCategories(subCatid,catid)
    setCategories(data.data.data)
  }

  const handleEditCatgory = (product) => {
    setAddCategory(true)
    setEditCat(true)
    setEditId(product._id)
    setAttributeSearch('');
    setForm({
      ...EMPTY_FORM,
      ...product,
      attributeKeys: Array.isArray(product.attributeKeys) ? product.attributeKeys : [],
      subcategoryImage: null,
    });
  }

  const toggleAttributeKey = (attributeKey) => {
    setForm((previousForm) => ({
      ...previousForm,
      attributeKeys: previousForm.attributeKeys.includes(attributeKey)
        ? previousForm.attributeKeys.filter((key) => key !== attributeKey)
        : [...previousForm.attributeKeys, attributeKey],
    }));
  };

  const filteredAttributeKeys = ATTRIBUTE_KEYS.filter((attributeKey) =>
    attributeKey.toLowerCase().includes(attributeSearch.trim().toLowerCase())
  );

  const handleProductStatusChange = async (e,product) => {
      e.stopPropagation();
      const updatedStatus = !product.status;
      let resp = await UpdateSubSubCategoryStatus(product._id,{status:updatedStatus})
      if(resp.data.message === "SUCCESSFULLY_UPDATED"){
        Swal.fire("Status Updated")
        getCategory()
      }
  }

  return (
    <ProductsPage>
      <PageHeader>
        <PageTitle>Sub Sub Category Management</PageTitle>
        <AddProductButton onClick={() => {
          setAddCategory(true)
          setEditCat(false)
          setEditId('')
          setForm(EMPTY_FORM)
          setAttributeSearch('')
        }
        }>+ Add New Sub Sub Categories</AddProductButton>
      </PageHeader>
      <ProductsStats style={{ marginBottom: "20px" }}>
        {/* <StatItem>
          <ListInfo style={{ flex: 0.5 }}>
            <img src='../assets/mens.png' alt={'men'} width={80} />
          </ListInfo>
          <StatNumber>Mens</StatNumber>
          <StatLabel>Main Category</StatLabel>
        </StatItem> */}
      </ProductsStats>
      <TabsWrapper style={{ marginTop: "10px" }}>
        {/* Tabs */}
        <TabHeader>
          <TabButton active={activeTab === "tab1"} onClick={() => setActiveTab("tab1")}>
            Active Sub Category
          </TabButton>
          <TabButton active={activeTab === "tab2"} onClick={() => setActiveTab("tab2")}>
            Deactive Sub Category
          </TabButton>
        </TabHeader>
        <Header>
          <div>S No.</div>
          <div>Images</div>
          <div>Category</div>
          <div>Sort Order</div>
          <div>Status</div>
          <div>Actions</div>
        </Header>
        {activeTab === "tab1" && (
          categories?.filter((item) => item.status).length > 0 ? categories?.filter((item) => item.status).map((product, id) => (
            <Row key={product._id} 
            // onClick={() => SubCategory(product._id)}
            >
              <ProductName>{id + 1}</ProductName>
              <ProductName>
                <img src={product.subcategoryImage ? product.subcategoryImage : '/assets/defaultimage.png'} alt={product.subcategoryImage} width={50} />
              </ProductName>
              <div>
                <ProductName>{product.subcategoryName}</ProductName>
                <ProductDesc>{product.description}</ProductDesc>
              </div>
              <div>
                <ProductName>{product.sortOrder}</ProductName >
              </div>
              
              <Status style={{ cursor: 'pointer' }}
                onClick={(e) => handleProductStatusChange(e,product)} 
                value={product.status} verified={product.status}>{product.status ? "Enable" : "Disable"}</Status>
              <UserActions>
                <ActionButton className="edit" type="verify"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditCatgory(product);
                  }}
                >✏️</ActionButton>
              </UserActions>
            </Row>
          )) : <div style={{margin:"100px",display:"flex",justifyContent:"center"}}>Active Sub Category Not Found</div>
        )}
        {activeTab === "tab2" && (
          categories?.filter((item) => !item.status).length > 0 ? categories?.filter((item) => !item.status).map((product, id) => (
            <Row key={product._id} 
            // onClick={() => SubCategory(product._id)}
            >
              <ProductName>{id + 1}</ProductName>
              <ProductName>
                <img src={product.subcategoryImage ? product.subcategoryImage : '/assets/defaultimage.png'} alt={product.subcategoryImage} width={50} />
              </ProductName>
              <div>
                <ProductName>{product.subcategoryName}</ProductName>
                <ProductDesc>{product.description}</ProductDesc>
              </div>
              <div>
                <ProductName>{product.sortOrder}</ProductName >
              </div>

              <Status style={{ cursor: 'pointer' }}
                onClick={(e) => handleProductStatusChange(e,product)} 
                value={product.status} verified={product.status}>{product.status ? "Enable" : "Disable"}</Status>
              <UserActions>
                <ActionButton className="edit" type="verify"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditCatgory(product);
                  }}
                >✏️</ActionButton>
              </UserActions>
            </Row>
          )) : <div style={{margin:"100px",display:"flex",justifyContent:"center"}}>No Deactive Sub Category Found</div>
        )}
      </TabsWrapper>
      {
        addCategory &&
        <ModalOverlay>
          <ModalContent>
            <HeadersModal>
              <h2>Add Sub Sub Categories</h2>
              <img onClick={() => setAddCategory(false)} style={{ width: "18px" }} src='/assets/close.png' />
            </HeadersModal>

            <Field>
              <Label>Sub Sub Category</Label>
              <Input name="subcategoryName"
                value={form.subcategoryName} onChange={handleChange}
              />
            </Field>
            <Field>
              <Label>Description</Label>
              <Input name="description"
                value={form.description} onChange={handleChange}
              />
            </Field>
            <Field>
              <Label>Product Attribute Keys</Label>
              <AttributeSelector>
                <AttributeSearchInput
                  type="search"
                  value={attributeSearch}
                  placeholder="Search and select fields..."
                  onChange={(event) => {
                    setAttributeSearch(event.target.value);
                    setShowAttributeOptions(true);
                  }}
                  onFocus={() => setShowAttributeOptions(true)}
                />
                {showAttributeOptions && (
                  <AttributeOptions>
                    {filteredAttributeKeys.length > 0 ? filteredAttributeKeys.map((attributeKey) => (
                      <AttributeOption key={attributeKey}>
                        <input
                          type="checkbox"
                          checked={form.attributeKeys.includes(attributeKey)}
                          onChange={() => toggleAttributeKey(attributeKey)}
                        />
                        <span>{attributeKey}</span>
                      </AttributeOption>
                    )) : <EmptyAttributeOption>No matching fields</EmptyAttributeOption>}
                  </AttributeOptions>
                )}
              </AttributeSelector>
              {form.attributeKeys.length > 0 && (
                <SelectedAttributes>
                  {form.attributeKeys.map((attributeKey) => (
                    <AttributeTag key={attributeKey}>
                      {attributeKey}
                      <button type="button" onClick={() => toggleAttributeKey(attributeKey)} aria-label={`Remove ${attributeKey}`}>×</button>
                    </AttributeTag>
                  ))}
                </SelectedAttributes>
              )}
              <AttributeHint>{form.attributeKeys.length} field(s) selected</AttributeHint>
            </Field>
            <Field>
              <Label>Status</Label>
              <Dropdown
                value={form.status}
                name="status"
                onChange={handleChange}
              >
                <Item value="true">Yes</Item>
                <Item value="false">No</Item>
              </Dropdown>
            </Field>
            <Field>
              <Label>Sort Order</Label>
              <Dropdown
                name="sortOrder"
                value={form.sortOrder}
                onChange={handleChange}
              >
                <Item value="1">1</Item>
                <Item value="2">2</Item>
                <Item value="3">3</Item>
                <Item value="4">4</Item>
                <Item value="5">5</Item>
              </Dropdown>
            </Field>
            <Field>
              <Label>Show in Menu</Label>
              <Dropdown
                name="showInMenu"
                value={form.showInMenu}
                onChange={handleChange}
              >
                <Item value="true">Yes</Item>
                <Item value="false">No</Item>
              </Dropdown>
            </Field>
            <Field>
              <Label>Sub Sub Category Image</Label>
              <Input
                type='file'
                name="subcategoryImage"
                accept="image/*"
                onChange={handleChange}
              />
            </Field>
            <AddButton onClick={handleSubmit}>{editCat ? 'Edit' : 'Add'}</AddButton>
          </ModalContent>
        </ModalOverlay>
      }
    </ProductsPage>
  );
};

export default SubSubCategory;




const Wrapper = styled.div`padding: 30px 0px; background: #f7f9fb; min-height: 100vh;`;
const Table = styled.div`width: 100%; border-radius: 12px; background: white; overflow-x: auto; box-shadow: 0 4px 10px rgba(0,0,0,0.05);`;
const Header = styled.div`
  display: grid; grid-template-columns: 120px 1.8fr 1fr 1fr 1fr 0.8fr 1fr; padding: 14px 20px;
  background: #f1f3f6; font-weight: 600; font-size: 14px;
  min-width: 960px;

  @media (max-width: 768px) { display: none; }
`;
const Row = styled.div`
  display: grid; grid-template-columns: 120px 1.8fr 1fr 1fr 1fr 0.8fr 1fr; padding: 14px 20px; align-items: center;
  border-bottom: 1px solid #eee; &:hover { background: #fafafa; }
  cursor:pointer;
  min-width: 960px;

  @media (max-width: 768px) {
    min-width: 0;
    grid-template-columns: 86px 1fr;
    gap: 12px;
    margin: 10px;
    padding: 14px;
    border: 1px solid #e2e8f0;
    border-radius: 10px;

    > :first-child { grid-row: 1 / span 3; }
    > * { min-width: 0; overflow-wrap: anywhere; }
  }

  @media (max-width: 420px) {
    grid-template-columns: 1fr;
    > :first-child { grid-row: auto; }
  }
`;
const ProductName = styled.div`font-weight: 600; font-size: 15px; color: #111; margin-bottom: 3px;`;
const ProductDesc = styled.div`font-size: 13px; color: #555;`;
const Status = styled.div`
  font-size: 13px; font-weight: 500;
  color: ${({ verified }) => (verified ? "#056d3b" : "#a61b1b")};
  background: ${({ verified }) => (verified ? "#d4f5e9" : "#fde4e4")};
  padding: 6px 10px; border-radius: 8px; text-align: center; width: fit-content;
`;
const AttributeSelector = styled.div`
  position: relative;
`;
const AttributeSearchInput = styled(Input)`
  width: 100%;
  box-sizing: border-box;
`;
const AttributeOptions = styled.div`
  max-height: 210px;
  overflow-y: auto;
  margin-top: 6px;
  padding: 6px;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.12);
`;
const AttributeOption = styled.label`
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 8px 9px;
  border-radius: 6px;
  cursor: pointer;

  &:hover { background: #f4f7fb; }
`;
const EmptyAttributeOption = styled.div`
  padding: 10px;
  color: #64748b;
  font-size: 13px;
`;
const SelectedAttributes = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;
`;
const AttributeTag = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 8px;
  border-radius: 999px;
  background: #edf2ff;
  color: #334e9e;
  font-size: 12px;

  button {
    padding: 0;
    border: 0;
    background: transparent;
    color: inherit;
    cursor: pointer;
    font-size: 16px;
    line-height: 1;
  }
`;
const AttributeHint = styled.div`
  margin-top: 7px;
  color: #64748b;
  font-size: 12px;
`;
